import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";
import AgeWiseStocksChart from "../../../Components/Charts/PipeLineChart"; // Chart component

const pipeLineConversionAPI = async (body) => {
  try {
    const res = await axInst.post("pipeline/graph", body);
    return res.data;
  } catch (error) {
    console.error("Error fetching pipeline conversion data:", error);
    throw new Error("Failed to fetch pipeline conversion data");
  }
};

const PipeLineConversion = () => {
  const [selOps, setSelOps] = useState({ no_of_days: "30" });
  const [selectedOption, setSelectedOption] = useState("30");

  const handleDropdownChange = (event) => {
    const selectedOption = event.target.value;
    setSelOps({ no_of_days: selectedOption });
    setSelectedOption(selectedOption);
  };

  const { data, submitted } = useSelector((e) => e.filtersPipeline);
  const {
    data: ConversionData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["conversion", submitted, selOps.no_of_days],
    queryFn: () => pipeLineConversionAPI({ ...data, ...selOps }),
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
    cacheTime: 0,
    staleTime: 0,
  });
  return (
    <div className="relative p-2">
      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Error Occurred</p>
        </div>
      )}
      <WaterMark />
      {!isFetching && !isError && ConversionData && (
        <div>
          <AgeWiseStocksChart
            data={ConversionData}
            heading="Pipeline Conversion"
          />
          <div className="absolute top-2 right-0 mr-2 flex items-center">
            <select
              value={selectedOption}
              onChange={handleDropdownChange}
              className="border border-gray-300 text-sm rounded-md h-6 w-36 pl-1 focus:outline-none"
            >
              <option value="30">Pipeline &gt; 30 Days</option>
              <option value="7">Pipeline &gt; 7 Days </option>
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default PipeLineConversion;
